import { SELECTION_CAP } from 'areas/search/hooks';
import { faClipboardCheck, faShareSquare } from '@fortawesome/pro-light-svg-icons';
import { IAction } from './interfaces';
import { AssignCaseworkerTaskDialog } from '../modals/assign-caseworker-for-task/assign-caseworker-for-task';
import { ConfirmCompleteTasksDialog } from '../modals/confirm-complete-tasks-dialog/confirm-complete-tasks-dialog';

export const actions: IAction[] = [
  {
    context: 'Tasks',
    id: 'TaskAssignTeamOrUser',
    displayName: 'Tildel',
    icon: faShareSquare,
    action: (selectedEntries, _selectedRootIds, _isFeatureEnabled, _replaceUrl, _selectedEntities, onActionCompleted) => (
      <AssignCaseworkerTaskDialog taskIds={selectedEntries} onCompleted={onActionCompleted} />
    ),
    isVisible: selectedItemsCount => selectedItemsCount > 0,
    isDisabled: selectedItemsCount => (selectedItemsCount > SELECTION_CAP ? `Antallet af valgte elementer må ikke overstige ${SELECTION_CAP}` : ''),
  },
  {
    context: 'Tasks',
    id: 'CompleteActivity',
    displayName: 'Afslut opgaver og aftaler',
    icon: faClipboardCheck,
    action: (selectedEntries, _selectedRootIds, _isFeatureEnabled, _replaceUrl, _selectedEntities, onActionCompleted) => (
      <ConfirmCompleteTasksDialog taskIds={selectedEntries} onCompleted={onActionCompleted} />
    ),
    isVisible: selectedItemsCount => selectedItemsCount > 0,
    isDisabled: selectedItemsCount => (selectedItemsCount > SELECTION_CAP ? `Antallet af valgte elementer må ikke overstige ${SELECTION_CAP}` : ''),
  },
];
